// extracted by mini-css-extract-plugin
export default {"wrapper":"Yy-z","viewport":"Zy-z","container":"_y-z","slide":"az-z"};